import { N8N_COURSES } from './n8n/courses';
import { ZAPIER_COURSES } from './zapier/courses';
import { MAKE_COURSES } from './make/courses';

export const AUTOMATION_COURSES = [
  ...N8N_COURSES,
  ...ZAPIER_COURSES,
  ...MAKE_COURSES
  // Future: Node-RED, Airflow, Temporal, etc.
];

export * from './types';
export * from './n8n';
